import React, {Component} from "react";

export default class ConditionalBlock extends Component {
    render() {
        if (!this.props.show)
            return null;
        return this.props.children;
    }
}